<template>
  <q-input
    v-model="texto"
    dense
    :clearable="clearable"
    :label="label"
    mask="##/##/####"
    :error="error"
    :error-message="errorMessage"
    @update:model-value="digitar"
    @click="$refs.calendario.show()"
  >
    <template v-slot:append>
      <q-icon name="event" class="cursor-pointer">
        <q-popup-proxy ref="calendario" transition-show="scale" transition-hide="scale">
          <q-date
            minimal
            today-btn
            mask="YYYY-MM-DD"
            :locale="langDate"
            :model-value="value"
            @update:model-value="escolher"
          />
        </q-popup-proxy>
      </q-icon>
    </template>
  </q-input>
</template>

<script>
import negociosMixin from "@/mixins/negocios";

import moment from "moment";

export default {
  name: "negocios-campo-data",

  emits: ["input"],
  mixins: [negociosMixin],
  props: {
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      required: true
    },
    clearable: {
      type: Boolean,
      default: true
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      texto: this.dataParaTela(this.value)
    };
  },
  watch: {
    value(valor) {
      this.texto = this.dataParaTela(valor);
    }
  },
  methods: {
    digitar(texto) {
      if (!texto) {
        return this.$emit("input", null);
      }

      const data = moment(texto, "DD/MM/YYYY", true);

      if (data.isValid()) {
        this.$emit("input", data.format("YYYY-MM-DD"));
      }
    },
    escolher(valor) {
      this.$emit("input", valor);
      this.$refs.calendario.hide();
    }
  }
};
</script>
